export class LoginInfo {
  accessToken: string
  expiresAt: string
  idToken: string
  refreshToken: string
  tokenType: string
  expiresIn: number

  constructor(data?: Record<string, string>) {
    this.accessToken = data?.accessToken || ''
    this.expiresAt = data?.expiresAt || ''
    this.idToken = data?.idToken || ''
    this.refreshToken = data?.refreshToken || ''
    this.tokenType = data?.tokenType || ''
    this.expiresIn = Number(data?.expiresIn || 0)
  }
}

export class RefreshTokenRequest {
  RefreshToken: string

  constructor(tokenToRefresh?: string) {
    this.RefreshToken = tokenToRefresh || ''
  }
}